import PrintShiftReports from "./PrintShiftReports";

// تتلقى payload أو مصفوفة sessions، ثم تستدعي PrintShiftReports
export const printDailyShiftUtils = async (payload = {}, options = {}) => {
  // دعم استدعاء قديم (مصفوفة مباشرة) أو كائن payload يحتوي transactions + totals + tableHtml
  const sessions = Array.isArray(payload) ? payload : payload.transactions || [];
  const totals = payload && !Array.isArray(payload) ? (payload.totals || {}) : {};
  const tableHtml = payload && !Array.isArray(payload) ? payload.tableHtml : undefined;
  const printWindow = window.open("", "printWindow", "width=900,height=700");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  try {
    // تمرير البيانات والمجاميع و html الجدول ضمن options إلى مولّد الـ HTML
    const html = await PrintShiftReports(sessions, { totals, tableHtml, ...options });

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();

    const tryClose = () => {
      try {
        if (printWindow && !printWindow.closed) printWindow.close();
      } catch (e) {
        /* ignore */
      }
    };

    printWindow.onafterprint = tryClose;
    try {
      printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
    } catch (e) {
      /* ignore */
    }

    const fallbackTimer = setTimeout(() => {
      tryClose();
    }, 12000);

    const clearIfClosed = () => {
      if (!printWindow || printWindow.closed) {
        clearTimeout(fallbackTimer);
        try {
          printWindow.onafterprint = null;
          printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
        } catch (e) {}
      }
    };

    printWindow.print();
    const pollInterval = setInterval(() => {
      if (!printWindow || printWindow.closed) {
        clearInterval(pollInterval);
        clearIfClosed();
      }
    }, 500);
  } catch (err) {
    console.error("❌ خطأ أثناء تجهيز أو طباعة تقرير اليومية:", err);
    alert("فشل في تجهيز تقرير الطباعة.");
    try {
      if (!printWindow.closed) printWindow.close();
    } catch (e) {}
  }
};
